module.exports = __webpack_public_path__ + "static/media/instabox.8c86ef55.png";